<template>
  <div class="import-wrap">
    <span class="common-list-header-export" @click.stop="dialogVisible = true">
      <i class="iconfont iconicon_Export"></i>导出{{moduleName}}
    </span>
    <el-dialog
      class="import-modal"
      :title="`${moduleName}导出`"
      :visible.sync="dialogVisible"
      width="450px"
      @close="handleCancel"
      >
      <div class="export-content">
        <div class="export-content-radio" v-if="exportStatus === -1">
          <el-radio class="mb12" v-model="exportType" label="1">所有</el-radio>
          <el-radio class="mb12" v-model="exportType" label="2">当前筛选条件</el-radio>
          <el-radio v-model="exportType" label="3" v-if="!hideSelectedRow" :disabled="ids.length === 0">选中{{moduleName}}（{{ids.length}}）</el-radio>
        </div>
        <div class="exporting-page" v-if="exportStatus === 0">
          <p class="exporting-desc">关闭本弹窗不影响文件生成，文件生成后将通知你</p>
          <p><i class="el-icon-loading"></i></p>
          导出中...
        </div>
        <div class="exported-page" v-if="exportStatus === 1">
          <p><i class="el-icon-folder-checked"></i></p>
          文件已生成
        </div>
        <div class="export-content-operation">
          <el-button class="width120 mr16" @click="handleCancel">取消</el-button>
          <el-button :disabled="exportStatus === 0" v-if="exportStatus !== 1" class="width120" type="primary" @click="handleExport">导出</el-button>
          <download-btn :url="downloadUrl" :fileName="downloadFileName">
            <el-button v-if="exportStatus === 1" class="width120" type="primary">
              点击下载
            </el-button>
          </download-btn>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import DownloadBtn from '@/components/common/download-btn'
export default {
  name: 'ZExportFile',
  props: {
    getSearchParams: {
      type: Function,
      required: true
    },
    moduleName: {
      type: String,
      default: ''
    },
    exportFn: {
      type: Function,
      required: true
    },
    ids: {
      type: Array,
    },
    checkExportStatus: {
      type: Function,
      required: true
    },
    hideSelectedRow: {
      type: Boolean,
      default: true
    },
    async: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DownloadBtn
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      exportStatus: -1, // 0:进行中 1:已完成 2:超时失败
      exportType: '1',
      timer: null,
      downloadUrl: '',
      downloadFileName: '',

    }
  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    handleExportSearchParams() {
      
    },
    reset() {
      this.loading = false
      this.exportStatus = -1
      this.exportType = '1'
      this.timer = null
      this.downloadUrl = ''
      this.downloadFileName = ''
    },
    handleCancel() {
      this.dialogVisible = false
      this.reset()
      this.$emit('cancel-fn')
    },
    async handleExport() {
      const searchParams = this.getSearchParams(this.exportType)
      let params = {
        exportsType: this.exportType
      }
      if (this.exportsType !== '1') {
        params = { 
          ...searchParams,
          ...params
        }
      }
      const { data } = await this.exportFn(params)
      if (data.code === this.$code) {
        const taskId = data.data.id
        this.exportStatus = 0
        this.exportFileStatus(taskId)
      }
    },
    async exportFileStatus(taskId) {
      const { data } = await this.checkExportStatus(taskId)
      if (data.code === this.$code) {
        if (data.data.status === 0) {
          setTimeout(() => {
            this.exportFileStatus(taskId)
          }, 5000)
        } else if (data.data.status === 1) {
          this.exportStatus = data.data.status
          this.downloadUrl = data.data.fileUrl
          this.downloadFileName = data.data.fileName
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.import-wrap {
  display: inline-block;
}
.ml12 {
  margin-left: 12px;
}
.ml16 {
  margin-left: 16px;
}
.mr16 {
  margin-right: 16px;
}
.mr12 {
  margin-right: 12px;
}
.mb12 {
  margin-bottom: 12px;
}
.mb16 {
  margin-bottom: 16px;
}
.width120 {
  width: 120px;
}
.export-content {
  &-radio {
    display: flex;
    flex-direction: column;
  }
  &-operation {
    margin-top: 68px;
    text-align: center;
  }
  .download-btn {
    color: #fff;
  }
  .exporting-page {
    text-align: center;
    p {
      font-size: 56px;
    }
    .exporting-desc {
      font-size: 14px;
      color: $--table-font-color;
      margin-bottom: 8px;
    }
  }
  .exported-page {
    text-align: center;
    p {
      font-size: 56px;
      color: #52c41a;
    }
  }
}
</style>
